let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("icyPI")).then(() => parcelRequire('1d4Mb'));